import { useEffect, useState } from 'preact/hooks';

const events = [
	'mousedown',
	'mousemove',
	'keydown',
	'keypress',
	'touchstart',
	'touchend',
	'click'
];

const isTestEnvironment = () => {
	return process.env.NODE_ENV === 'test';
};

export default function useDetectInteraction() {
	// In test environment, immediately return true to avoid blocking test scenarios
	const [interactionDetected, setInteractionDetected] = useState(isTestEnvironment());

	useEffect(() => {
		if (isTestEnvironment()) {
			return;
		}

		const handleEvent = () => {
			setInteractionDetected(true);
			clearListeners();
		};

		const clearListeners = () => {
			events.forEach(event => {
				document.removeEventListener(event, handleEvent);
			});
		};

		events.forEach(event => {
			document.addEventListener(event, handleEvent, { once: true });
		});

		return () => {
			clearListeners();
		};
	}, []);

	return interactionDetected;
}
